import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Button } from 'ui-components/components/button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator/';
import { noop } from 'ui-components/default-props/noop';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { emptyArray } from 'ui-components/default-props/empty';
import { CreateLabelErrorsTable } from './table';

import style from './style.module.less';

export const LabelBatchCreateErrors = ({
  errorCount = 0,
  warnCount = 0,
  errorOrWarnCollection = emptyArray,
  onRemoveFromBatch = noop,
  isLoading = true,
  modalFrameworkMethods,
  batchId,
  onRetryBatch = noop,
  fetchErrorsOrWarnings = noop,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const onRetry = useCallback(() => {
    onRetryBatch(batchId);
  }, [batchId, onRetryBatch]);

  const toggleExpand = useCallback(() => {
    if (!isExpanded) {
      fetchErrorsOrWarnings(batchId);
    }
    setIsExpanded(!isExpanded);
  }, [batchId, fetchErrorsOrWarnings, isExpanded]);

  if (errorCount + warnCount === 0) {
    return null;
  }

  return (
    <div className={style['create-label-errors']}>
      <div className={style['expander-header']}>
        <Button
          className={classnames(style.expander, {
            [style.expanded]: isExpanded,
          })}
          onClick={toggleExpand}
          theme='unstyled'
        >
          <FontAwesomeIcon icon={faCaretRight} />
          {errorCount > 0 && (
            <div className={style['error-text']}>
              <FormattedMessage
                defaultMessage='{errorCount} Errors'
                description='labelBatch.errorCount'
                id='73cKCJ'
                values={{ errorCount }}
              />
            </div>
          )}
          {warnCount > 0 && (
            <div className={style['warning-text']}>
              <FormattedMessage
                defaultMessage='{warnCount} Warnings'
                description='labelBatch.warnCount'
                id='eHDhLU'
                values={{ warnCount }}
              />
            </div>
          )}
        </Button>
      </div>
      {isExpanded && isLoading && <LoadingIndicator className={style['loading-indicator']} />}
      {isExpanded && !isLoading && (
        <CreateLabelErrorsTable
          batchId={batchId}
          errorOrWarnCollection={errorOrWarnCollection}
          modalFrameworkMethods={modalFrameworkMethods}
          onRemoveFromBatch={onRemoveFromBatch}
          onRetryBatch={onRetry}
        />
      )}
    </div>
  );
};

LabelBatchCreateErrors.propTypes = {
  isLoading: PropTypes.bool,
  errorCount: PropTypes.number,
  warnCount: PropTypes.number,
  fetchErrorsOrWarnings: PropTypes.func,
  errorOrWarnCollection: PropTypes.array,
  onRetryBatch: PropTypes.func,
  onRemoveFromBatch: PropTypes.func,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  batchId: PropTypes.string,
};
